import { combineReducers } from 'redux';

import * as PagingConstants from './paging/constants';
import sites from './sites/reducer';
import dirtyTracking from './dirtyTracking/reducer';
import timeZones from './timeZones/reducer';
import grades from './grades/reducer';
import caseTypes from './caseTypes/reducer';
import controlInfo from './controlInfo/reducer';
import connection from './connection/reducer';
import serverTime from './serverTime/reducer';
import app from './app/reducer';
import filters from './filters/reducer';
import gridPreference from './gridPreference/reducer';
import getRecipe from './getrecipe/reducer';
import dragAndDrop from './dragAndDrop/reducer';
import report from './report/reducer';
import createCommonStatePagingReducer from './paging/reducer';
import getFiscalYears from './fiscalYears/reducer';
import pageStateCache from './pagestatecache/reducer';
import products from './product/reducer';

const paging = createCommonStatePagingReducer(PagingConstants.primaryPrefix);
const secondaryPaging = createCommonStatePagingReducer(
  PagingConstants.secondaryPrefix
);

export default combineReducers({
  app,
  caseTypes,
  connection,
  controlInfo,
  dirtyTracking,
  grades,
  serverTime,
  sites,
  timeZones,
  filters,
  gridPreference,
  getRecipe,
  dragAndDrop,
  report,
  paging,
  secondaryPaging,
  getFiscalYears,
  pageStateCache,
  products,
});



// WEBPACK FOOTER //
// ./src/state/reducer.js